module.exports = __webpack_public_path__ + "img/pesquisa_contacto.3bc0d34b.gif";